import { useEffect } from "react";

export const usePreventIndex = () => {
  useEffect(() => {
    let meta: HTMLMetaElement | null = document.querySelector('meta[name="robots"]');

    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.appendChild(meta);
    }

    meta.content = "noindex, nofollow";

    return () => {
      if (meta) meta.remove();
    };
  }, []);
};